export const IS_DEV = process.env.NODE_ENV !== "production";
export const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const NEXT_PUBLIC_KRAVEN_HASURA = process.env.NEXT_PUBLIC_KRAVEN_HASURA;
export const NEXT_PUBLIC_ROGUE = process.env.NEXT_PUBLIC_ROGUE;
export const NEXT_PUBLIC_SLS = process.env.NEXT_PUBLIC_SLS;
export const NEXT_PUBLIC_ACCESS_TOKEN = process.env.NEXT_PUBLIC_ACCESS_TOKEN || undefined;
export const NEXT_PUBLIC_CREDENTIALS_URL = process.env.NEXT_PUBLIC_CREDENTIALS_URL;
export const NEXT_PUBLIC_MS_SKILL_MATCHER = process.env.NEXT_PUBLIC_MS_SKILL_MATCHER;
export const NEXT_PUBLIC_HOSTNAME = process.env.NEXT_PUBLIC_HOSTNAME || "";

export const DATADOG_APP_VERSION = process.env.NEXT_PUBLIC_DATADOG_APP_VERSION as string;
export const DATADOG_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN as string;
export const DATADOG_APPLICATION_ID = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID as string;
export const DATADOG_SERVICE_NAME = process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME as string;
